import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
      <Toaster position="top-center" richColors />
    </AuthProvider>
  </React.StrictMode>
);

// تسجيل Service Worker لتفعيل إمكانية تثبيت التطبيق على شاشة الجوال
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {
      // فشل التسجيل لا يوقف عمل التطبيق العادي، فقط تعطيل خاصية التثبيت
    });
  });
}